// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"nQ-z","inlineTitle":"oQ-z","sponsoredAdsWrapper":"pQ-z","marketplaceRecosWrapper":"qQ-z"};